<template lang="pug">
swiper(ref="sw" :options="swiperOptions" @slideChange="handleSlideChange")
  //- small {{ mmoDetails['hdp'] }}
  template(v-if="isShow")
    swiper-slide
      .odds-wrapper
        .odds-group.two-col
          .m-label-top {{ $tc("m.BT_HDPF", 2) }} 
          .m-label-top {{ $tc("m.BT_OUF", 2) }}
          template(v-if="Object.keys(mmoDetails).length > 0 && mmoDetails['tn'] > 0")
            template(v-for="(dn, i) in mmoDetails['kns']")
              template(v-if="mmoDetails['hdp'] && mmoDetails['hdp'][i] && mmoDetails['hdp'][i][9] != 0 && mmoDetails['hdp'][i][10] != 0 && mmoDetails['hdp'][i][9] != '' && mmoDetails['hdp'][i][10] != ''")
                oddsItemMMOX(:odds="mmoDetails['hdp'][i]" :idx="mmoDetails['hdp'][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="mmoDetails" homeAway="1" pos=22)
              template(v-else)
                OddsDisabled
              template(v-if="mmoDetails['ou'] && mmoDetails['ou'][i] && mmoDetails['ou'][i][11] != 0 && mmoDetails['ou'][i][12] != 0 && mmoDetails['ou'][i][11] != '' && mmoDetails['ou'][i][12] != ''")
                oddsItemMMOX(:odds="mmoDetails['ou'][i]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" :count="i" :details="mmoDetails" homeAway="1" pos=23)
              template(v-else)
                OddsDisabled

              template(v-if="mmoDetails['hdp'] && mmoDetails['hdp'][i] && mmoDetails['hdp'][i][9] != 0 && mmoDetails['hdp'][i][10] != 0 && mmoDetails['hdp'][i][9] != '' && mmoDetails['hdp'][i][10] != ''")
                oddsItemMMOX(:odds="mmoDetails['hdp'][i]" :idx="mmoDetails['hdp'][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" mode="hdp" :count="i" :details="mmoDetails" homeAway="2" pos=22)
              template(v-else)
                OddsDisabled
              template(v-if="mmoDetails['ou'] && mmoDetails['ou'][i] && mmoDetails['ou'][i][11] != 0 && mmoDetails['ou'][i][12] != 0 && mmoDetails['ou'][i][11] != '' && mmoDetails['ou'][i][12] != ''")
                oddsItemMMOX(:odds="mmoDetails['ou'][i]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" :count="i" :details="mmoDetails" homeAway="2" pos=23)
              template(v-else)
                OddsDisabled
</template>

<script>
import oddsItemMMOX from "@/components/mobile/main/xitem/oddsItemMMOX";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    oddsItemMMOX,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  data() {
    return {
      activeIndex: 0,
      isShow: false,
      showing: 10,
      isSwiping: false,
      touchStartX: 0,
      touchStartY: 0,
      touchStartTime: 0,
      swipeBlockTimeout: null
    };
  },
  computed: {
    hasSecondSlide() {
      return !!(this.details && (this.details['hdph'] || this.details['ouh'] || this.details['oxth']));
    },
    swiperOptions() {
      const hasOnlyOneSlide = !this.hasSecondSlide;
      const self = this;
      return {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: !hasOnlyOneSlide,
        simulateTouch: true,
        touchRatio: 1,
        touchAngle: 45,
        threshold: 5,
        resistance: true,
        resistanceRatio: 0.85,
        observer: true,
        observeParents: true,
        touchStartPreventDefault: true,
        preventClicks: true,
        preventClicksPropagation: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: (index, className) => {
            return '<span class="' + className + '"></span>';
          }
        },
        on: {
          init: function() {
            self.handleSwiperInit();
          },
          touchStart: function(swiper, event) {
            self.handleTouchStart(event);
          },
          touchMove: function(swiper, event) {
            self.handleTouchMove(event);
          },
          touchEnd: function(swiper, event) {
            self.handleTouchEnd(event);
          }
        }
      };
    },
    swiper() {
      return this.$refs.sw ? this.$refs.sw.$swiper : 0;
    }
  },
  watch: {
    hasSecondSlide(newVal) {
      this.$nextTick(() => {
        if (this.swiper && this.swiper.params) {
          this.swiper.allowTouchMove = newVal;
          this.swiper.update();
          if (this.swiper.pagination) {
            this.swiper.pagination.render();
            this.swiper.pagination.update();
          }
        }
      });
    },
    isShow(newVal) {
      if (newVal && this.swiper) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.swiper) {
              if (this.swiper.params) {
                this.swiper.allowTouchMove = this.hasSecondSlide;
              }
              this.swiper.update();
              if (this.swiper.pagination) {
                this.swiper.pagination.render();
                this.swiper.pagination.update();
              }
            }
          }, 100);
        });
      }
    }
  },
  mounted() {
    if (this.source.matchIndex <= this.showing) {
      this.isShow = true;
    } else {
      setTimeout(() => {
        this.isShow = true;
      }, this.source.matchIndex * 25);
    }
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.swiper) {
          this.activeIndex = this.swiper.activeIndex;
          if (this.swiper.params) {
            this.swiper.allowTouchMove = this.hasSecondSlide;
          }
          if (this.swiper.pagination && this.isShow) {
            this.swiper.pagination.render();
            this.swiper.pagination.update();
          }
          this.attachTouchListeners();
        }
      }, 150);
    });
  },
  beforeDestroy() {
    if (this.swipeBlockTimeout) {
      clearTimeout(this.swipeBlockTimeout);
    }
    if (this.swiper && this.swiper.el) {
      const swiperEl = this.swiper.el;
      swiperEl.removeEventListener('touchstart', this.handleTouchStart);
      swiperEl.removeEventListener('touchmove', this.handleTouchMove);
      swiperEl.removeEventListener('touchend', this.handleTouchEnd);
    }
  },
  methods: {
    toggleMoreMarkets() {
      this.$emit('toggle-more-markets');
    },
    handleSlideChange() {
      this.activeIndex = this.swiper.activeIndex;
      this.blockClicksTemporarily();
    },
    handleSwiperInit() {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.swiper) {
            if (this.swiper.params) {
              this.swiper.allowTouchMove = this.hasSecondSlide;
            }
            this.swiper.update();
            if (this.swiper.pagination && this.hasSecondSlide) {
              this.swiper.pagination.render();
              this.swiper.pagination.update();
            }
            this.attachTouchListeners();
          }
        }, 200);
      });
    },
    attachTouchListeners() {
      if (this.swiper && this.swiper.el) {
        const swiperEl = this.swiper.el;
        swiperEl.addEventListener('touchstart', this.handleTouchStart, { passive: true });
        swiperEl.addEventListener('touchmove', this.handleTouchMove, { passive: true });
        swiperEl.addEventListener('touchend', this.handleTouchEnd, { passive: true });
      }
    },
    handleTouchStart(event) {
      if (event && event.touches && event.touches.length > 0) {
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
        this.touchStartTime = Date.now();
        this.isSwiping = false;
      }
    },
    handleTouchMove(event) {
      if (event && event.touches && event.touches.length > 0 && this.touchStartX !== 0) {
        const deltaX = Math.abs(event.touches[0].clientX - this.touchStartX);
        const deltaY = Math.abs(event.touches[0].clientY - this.touchStartY);
        const threshold = 10;
        
        if (deltaX > threshold || deltaY > threshold) {
          this.isSwiping = true;
        }
      }
    },
    handleTouchEnd(event) {
      if (this.isSwiping) {
        this.blockClicksTemporarily();
      }
      this.touchStartX = 0;
      this.touchStartY = 0;
      this.touchStartTime = 0;
    },
    blockClicksTemporarily() {
      if (this.swipeBlockTimeout) {
        clearTimeout(this.swipeBlockTimeout);
      }
      
      const oddsItems = this.$el.querySelectorAll('.odd-box');
      oddsItems.forEach(item => {
        item.style.pointerEvents = 'none';
      });
      
      this.swipeBlockTimeout = setTimeout(() => {
        oddsItems.forEach(item => {
          item.style.pointerEvents = '';
        });
        this.isSwiping = false;
      }, 300);
    }
  },
};
</script>
